import { Grid } from 'ht-styleguide';
import Image from 'next/legacy/image';
import { BLOG_DETAILS } from '../locationPage.constants';
import styles from '../locationPage.module.scss';

const BlogPosts = () => (
  <Grid.Fluid classes="paddingY-huge">
    <Grid.Row classes="marginAuto">
      <Grid.Column sm={4} mdOffset={2} md={4} lgOffset={4} lg={4}>
        <h3 className="darkBlue700 text-align-center paddingBottom-large2">Featured Blog Posts</h3>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      {BLOG_DETAILS.map(blog => (
        <Grid.Column sm={4} lgOffset={0} lg={4} mdOffset={1} md={6} key={blog.title} classes="paddingX-small">
          <a href={blog.link} rel="noopener noreferrer" target="_blank" className="overrideLinkStyles">
            <div className={styles.blogImageDesktop}>
              <Image alt={blog.altText} quality={70} layout="fill" objectFit="cover" src={blog.image} objectPosition="bottom" />
            </div>
            <h5 className="marginTop-small2 marginBottom-medium darkBlue700">{blog.title}</h5>
          </a>
        </Grid.Column>
      ))}
    </Grid.Row>
  </Grid.Fluid>
);

export default BlogPosts;
